import { render, staticRenderFns } from "./AccountDropDown.vue?vue&type=template&id=be147c56&scoped=true&"
import script from "./AccountDropDown.vue?vue&type=script&lang=js&"
export * from "./AccountDropDown.vue?vue&type=script&lang=js&"
import style0 from "./AccountDropDown.vue?vue&type=style&index=0&id=be147c56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be147c56",
  null
  
)

export default component.exports